import i18n  from '@/lang';

export default [
  {
    path: '/CourseHome',
    name: 'CourseHome',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "CourseHome" */ '@/views/CourseHome/index.vue')
  },
  {
    path: '/AllReachingActivityModules',
    name: i18n.t('RouterName.所有教学活动模块') as string,
    component: () => import(/* webpackChunkName: "AllReachingActivityModules" */ '@/views/CourseHome/allReachingActivityModules.vue')
  },
  {
    path: '/studentEnrollCourseDetail',
    name: '学生报名详情',
    component: () => import(/* webpackChunkName: "studentEnrollCourseDetail" */ '@/views/EnrollCourse/studentEnrollCourseDetail/index.vue')
  },
  {
    path: '/courseEnrollInfo',
    name: '课程报名',
    component: () => import(/* webpackChunkName: "courseEnrollInfo" */ '@/views/EnrollCourse/courseEnrollInfo/index.vue')
  },
  {
    path: '/enrollReview',
    name: '报名审核',
    component: () => import(/* webpackChunkName: "enrollReview" */ '@/views/EnrollCourse/enrollReview/index.vue')
  },
  {
    path: '/enrollDetail',
    name: '审核详情',
    component: () => import(/* webpackChunkName: "enrollDetail" */ '@/views/EnrollCourse/enrollDetail/index.vue')
  },
  {
    path: '/folders',
    name: '文件夹',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "folders" */ '@/views/CourseHome/FolderList/index.vue')
  },
  {
    path: '/CourseRate',
    name: '课堂评价',
    component: () => import(/* webpackChunkName: "CourseRate" */ '@/views/CourseRateDetail/index.vue')
  },
  {
    path: '/EvaluationTeaching',
    name: '课堂评教',
    component: () => import(/* webpackChunkName: "EvaluationTeaching" */ '@/views/CourseRateDetail/evaluationTeaching.vue')
  },
  {
    path: '/course',
    name: '课程介绍',
    component: () => import(/* webpackChunkName: "EvaluationTeaching" */ '@/views/CourseHome/courseIntro/index.vue')
  },
]
